<template>
    <form autocomplete="off" class="home-delivery-modal__form" @submit.prevent="$emit('submit')">
        <div>
            <label class="home-delivery-modal__label" for="street">{{ $t('cart.step2.homeDeliveryModal.street') }}</label>
            <input
                id="street"
                v-model="street"
                type="text"
                class="home-delivery-modal__input smartform-instance-pilulka-expres smartform-address-street-and-number"
                autocomplete="off"
            />

            <div class="row">
                <div class="col-6">
                    <label class="home-delivery-modal__label" for="city">{{ $t('cart.step2.homeDeliveryModal.city') }}</label>
                    <input
                        id="city"
                        v-model="city"
                        type="text"
                        class="home-delivery-modal__input smartform-instance-pilulka-expres smartform-address-city"
                        autocomplete="off"
                    />
                </div>

                <div class="col-6">
                    <label class="home-delivery-modal__label" for="postCode">{{ $t('cart.step2.homeDeliveryModal.postCode') }}</label>
                    <input
                        id="postCode"
                        v-model="postCode"
                        type="text"
                        class="home-delivery-modal__input smartform-instance-pilulka-expres smartform-address-zip"
                        autocomplete="off"
                    />
                </div>
            </div>

            <button class="home-delivery-modal__button" data-cy="home-delivery-modal-post-code-button">
                {{ $t('cart.step2.homeDeliveryModal.submit') }}
            </button>
        </div>
        <div></div>
    </form>
</template>

<script lang="ts" setup>
const street = defineModel<string>('street', { required: true })
const city = defineModel<string>('city', { required: true })
const postCode = defineModel<string>('postCode', { required: true })

onMounted(() => {
    const isInitialLoad = useSmartForm(smartformInit)
    if (!isInitialLoad) {
        nextTick(() => {
            window.smartform.rebindAllForms()
            smartformInitInstances()
        })
    }
})

const config = useRuntimeConfig()

const smartformInit = () => {
    window.smartform = window.smartform || {}

    window.smartform.beforeInit = () => {
        window.smartform.setClientId(config.public.smartformClientId)
        window.smartform.enableSetAutocomplete(false)

        smartformInitInstances()
    }
}

const emit = defineEmits(['submit'])

let smartformTimeout: NodeJS.Timeout
const smartformInitInstances = () => {
    window.smartform.getInstanceIds().forEach((instanceId: string) => {
        const smartFormInstance = window.smartform.getInstance(instanceId)
        smartFormInstance.addressControl.setCountry(config.public.smartformCountry)
        smartFormInstance.addressControl.setSelectionCallback(
            (_elem: HTMLInputElement, _text: string, _fieldType: string, suggestion: any) => {
                clearTimeout(smartformTimeout)
                smartformTimeout = setTimeout(() => {
                    const suggestionValue = suggestion.getValue()
                    postCode.value = suggestionValue['smartform-address-zip'] || postCode.value
                    street.value = suggestionValue['smartform-address-street-and-number'] || street.value
                    city.value = suggestionValue['smartform-address-city'] || city.value
                    emit('submit')
                }, 200)
            }
        )
    })
}
</script>

<style lang="scss" scoped>
.home-delivery-modal {
    position: relative;

    &__form {
        display: grid;
        gap: 10px;
        align-items: end;

        @include screen-md {
        }
    }

    &__label {
        font-size: 15px;
        display: block;
        padding-bottom: 7px;
    }

    &__input {
        display: block;
        width: 100%;
        height: calc(1.5em + 1.1rem + 2px);
        padding: 0.55rem 0.75rem;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.5;
        color: #333;
        background-color: $color-grey;
        border: 2px solid $color-grey;
        border-radius: 10px;
        margin-bottom: 13px;
    }

    &__button {
        background: transparent;
        color: $color-cta;
        border: 1px solid $color-cta;
        border-radius: 50px;
        padding: 0 15px;
        width: 100%;
        font-size: 15px;
        font-weight: 500;
        line-height: 35px;
        cursor: pointer;
        transition: all 0.15s ease-in-out;

        &:hover {
            background: $color-cta;
            color: $color-white;
        }
    }
}
</style>
